import { render } from "./ReviewsProduct.vue?vue&type=template&id=8c25e25e"
import script from "./ReviewsProduct.vue?vue&type=script&lang=js"
export * from "./ReviewsProduct.vue?vue&type=script&lang=js"

import "./ReviewsProduct.vue?vue&type=style&index=0&id=8c25e25e&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__